import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { getCurrentLanguageCode } from "~utils/page-language"
import { useLocation } from "@reach/router"

export default (props) => {
  const { name } = props
  const location = useLocation()
  const gql = useStaticQuery(graphql`
    query {
      partials: allMdx(filter: { fields: { partialName: { ne: null } } }) {
        nodes {
          body
          fields {
            partialName
            language
          }
        }
      }
    }
  `)

  const language = getCurrentLanguageCode(location.pathname)

  const candidates = gql.partials.nodes.filter((p) => p.fields.partialName === name)
  if (candidates.length < 1) console.warn("Partial not found:", name)

  const item =
    candidates.find((p) => p.fields.language === language) ||
    candidates.find((p) => p.fields.language === "en-US") ||
    candidates[0]

  return item ? <MDXRenderer {...props}>{item.body}</MDXRenderer> : null
}
